import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { services } from '../mock';
import { Brush, Circle, ShoppingBag, Calendar } from 'lucide-react';

const iconMap = {
  Brush: Brush,
  Circle: Circle,
  ShoppingBag: ShoppingBag,
  Calendar: Calendar
};

const Services = () => {
  return (
    <section id="services" className="py-20 px-6 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight">
            Our <span className="text-red-600">Services</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Professional tattooing, piercing, and more
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <Card 
                key={service.id}
                className="service-card bg-zinc-900 border-zinc-800 overflow-hidden group hover:border-red-600 transition-all duration-300 hover:shadow-xl hover:shadow-red-600/20 transform hover:-translate-y-2"
              >
                <CardHeader className="pb-4">
                  <div className="w-16 h-16 bg-red-600/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-red-600/20 transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-red-600" />
                  </div>
                  <CardTitle className="text-2xl font-black text-white uppercase tracking-tight">
                    {service.name}
                  </CardTitle>
                </CardHeader>

                <CardContent className="space-y-4">
                  <p className="text-gray-400 leading-relaxed">
                    {service.description}
                  </p>

                  <div className="pt-4 border-t border-zinc-800">
                    <p className="text-red-500 font-bold text-lg">
                      {service.price}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-8 max-w-3xl mx-auto">
            <h3 className="text-2xl font-black text-white mb-4 uppercase">
              Walk-ins Welcome
            </h3>
            <p className="text-gray-400 text-lg leading-relaxed">
              While we recommend booking ahead, we also accept walk-ins based on artist availability. 
              All services include free touch-ups within the first 30 days.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
